export default "__VITE_ASSET__70c036a1__"